import React, { memo } from 'react'
import { Tooltip } from '../Tooltip'

export interface ITabProps extends JSX.ElementChildrenAttribute {
  // required
  label: string

  // optional
  count?: number
  dataTest?: string
  disabled?: boolean
  error?: boolean

  // optional, if not provided Tabs will supply it's label instead
  value?: string

  // following is supplied by Tabs
  active?: boolean
  onClick?: Function

  // tooltip
  tooltipMessage?: string
  icon?: JSX.Element
}

export const Tab = memo<ITabProps>(
  ({ active, count, dataTest, disabled, error, icon, label, onClick, tooltipMessage, value }) => {
    const clickHandler = () => {
      if (!disabled && !active && onClick) onClick(value)
    }
    const tabClasses = [
      'tab-item',
      active && 'active',
      error && 'tab-item-error',
      disabled && 'tab-item-disabled',
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <li className={tabClasses} data-test={dataTest}>
        <button
          role='tab'
          className='ph5 pv4'
          aria-selected={active}
          onClick={clickHandler}
          data-test={dataTest ? `${dataTest}-toggle` : undefined}>
          {icon && <span className='tab-icon'>{icon}</span>}
          {tooltipMessage ? (
            <Tooltip position='bottom' trigger={<span>{label}</span>}>
              {tooltipMessage}
            </Tooltip>
          ) : (
            label
          )}
          {count !== undefined && <span className='tab-counter'>{count}</span>}
        </button>
      </li>
    )
  }
)
